import { ApplicationState, isDone } from "#store/types";
import { createSelector } from "reselect";
import { HistoryDataTypeEnum, HistoryItem, UiState } from "#/store/ui/uiTypes";
import { isPresent, Optional } from "#types";
import { Interpretation } from "@inode/pilot-client-typescript-fetch";
import {
    selectInterpretationById,
    selectInterpretationsMap,
} from "#/selectors/interpretationSelectors";
import { InterpretationsMap } from "#store/interpretations";

export const selectUiHistory: (state: ApplicationState) => HistoryItem[] = (
    state: ApplicationState
) => {
    return state.uiState.history;
};

export const selectUiHistoryLatestInterpretation = createSelector(
    [selectUiHistory, selectInterpretationsMap],
    (
        history: HistoryItem[],
        interpretationsMap: InterpretationsMap
    ): Optional<Interpretation> => {
        const element = history.find(
            x => x.type === HistoryDataTypeEnum.INTERPRETATION
        );
        if (!element) {
            return undefined;
        } else {
            const interpretationsMapElement = interpretationsMap[element.id];
            if (
                isPresent(interpretationsMapElement) &&
                isDone(interpretationsMapElement)
            ) {
                return interpretationsMapElement.payload;
            } else {
                return undefined;
            }
        }
    }
);

export const selectUiHistoryLatestInterpretationsByDate = createSelector(
    [selectUiHistory, selectInterpretationsMap],
    (
        history: HistoryItem[],
        interpretationsMap: InterpretationsMap
    ): Interpretation[] => {
        const interpretationsInHistory = history.filter(
            x => x.type === HistoryDataTypeEnum.INTERPRETATION
        );
        const maxDate = Math.max(
            ...interpretationsInHistory.map(x => x.timestamp)
        );
        return interpretationsInHistory
            .filter(x => x.timestamp === maxDate)
            .map(x => {
                return interpretationsMap[x.id];
            })
            .filter(isPresent)
            .filter(isDone)
            .map(x => x.payload);
    }
);

export const selectUiState: (state: ApplicationState) => UiState = state => {
    return state.uiState;
};

export const selectUiUserId = createSelector(
    [selectUiState],
    (state: UiState) => state.rid
);
export const selectUiQuery = createSelector(
    [selectUiState],
    (state: UiState) => state.query
);
export const selectUiDatasource = createSelector(
    [selectUiState],
    (state: UiState) => state.selectedDatasource
);
